import React, { Component } from "react";
import Appbar from "./appbar";
import Signbutton from "../forms/button";
import { Input } from "../forms/input";
import DemoCarousel from "../auth/carsouel";
import { connect } from "react-redux";
import { userLogin, removeData, passwordPolicy_JMF } from "../../store/actions";

import { DASHBOARD_URL } from "../home/dashboard";
import { QueryAssistant } from "../home/home";
import Footer from "./footer";
import CustomLoader from "../forms/Loader";
import { Checkbox, Tooltip } from "@material-ui/core";
import Image from "../Image";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: { value: "" },
      password: { value: "" },
      showPassword: false,
      PosterOpen: true,
      display: false,
      terms: true,
      displayCommonArn: false,
      displayGenerateArn: false,
      displayEmpanelment: false,
      CamsData: "",
    };
  }
  async componentDidMount() {
    await this.props.removeData();
  }

  toggleCheckbox = () => {
    this.setState({ terms: !this.state.terms });
  };

  changeValue = (label) => (event) => {
    if (event.target.value.length <= 50) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  showError = (label) => (event) => {
    const {
      [label]: { value },
    } = this.state;
    this.setState({
      [label]: {
        value,
        isError: !value,
        errorMessage: `${
          label === "username"
            ? "User ID"
            : label === "password"
            ? "Password"
            : label
        } is mandatory`,
      },
    });
  };
  goTermsConditions = () => {
    this.props.history.push("/terms-conditions");
  };

  closePoster = () => {
    this.setState({
      PosterOpen: false,
    });
  };

  signIn = async () => {
    const {
      showPassword,
      display,
      terms,
      PosterOpen,
      displayEmpanelment,
      displayCommonArn,
      displayGenerateArn,
      CamsData,
      nonce,
      ...others
    } = this.state;
    const keys = Object.keys(others);
    const findError = keys.every((key) => {
      return !!this.state[key].value;
    });
    if (!findError) {
      keys.forEach((key) => {
        !this.state[key].value &&
          this.setState({
            [key]: {
              ...this.state[key],
              isError: true,
              errorMessage: `${
                key === "username"
                  ? "User Id"
                  : key === "password"
                  ? "Password"
                  : ""
              } is mandatory`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !this.state[key].value);
      switch (firstErroredKey) {
        case "username":
          this.usernameField.focus();
          break;
        case "password":
          this.passwordField.focus();
          break;
        default:
          break;
      }
    } else {
      if (!terms) {
        alert("Please accept the Terms and Conditions");
      } else {
        const nonce = Math.floor(100000 + Math.random() * 900000);
        this.setState({
          display: true,
          nonce,
        });
        const payload = {
          username: encrypt(this.state.username.value),
          password: encrypt(this.state.password.value),
          ReqBy: "M",
          nonce: encrypt(nonce),
          CustomFund: "189",
        };
        const response = await this.props.userLogin(payload);
        if (response && String(response?.nonce) !== String(this.state.nonce)) {
          this.setState({
            display: false,
            username: { value: "" },
            password: { value: "" },
          });
          alert("Unauthorized Request");
          return;
        }

        if (!!response && !!response.DtData && response.DtData.length > 0) {
          const { DtData } = response;
          this.setState({
            display: false,
          });

          if (DtData[0].tran_enable_flag === "N") {
            this.props.history.replace(DASHBOARD_URL);
          } else {
            this.props.history.replace(`/new-transaction`);
          }
        } else if (!response) {
          this.setState({
            display: false,
            username: {
              value: "",
              isError: true,
              errorMessage: "Please enter valid details",
            },
            password: {
              value: "",
              isError: true,
              errorMessage: "Please enter valid details",
            },
          });
        }
      }
    }
  };

  keyPress = (label) => (e) => {
    if (e.key === "Enter") {
      // Do code here
      if (label === "username") {
        this.passwordField.focus();
      } else {
        this.signIn();
      }
      e.preventDefault();
    }
  };

  gotoDistributorEmapanellement = () => {
    window.open("https://onboarding.bajajamc.com/login");
  };
  gotogenerateArnLink = () => {
    this.props.history.push("/generate-arn-link");
  };

  render() {
    const { username, password } = this.state;
    return (
      <div className="login-container" style={{ overflow: "hidden" }}>
        {/* <PosterDialog open={this.state.PosterOpen} close={this.closePoster} /> */}
        <Appbar />
        {/* <QueryAssistant /> */}
        <CustomLoader display={!!this.state.display} />
        <div className="login-without-appbar">
          <DemoCarousel />
          <div className="login-right-div" style={{ overflow: "scroll" }}>
            <div>
              {/* <div className="login-title" style={{ marginBottom: 10 }}>
                  Distributor Login
                </div> */}
              {/* <div
                  style={{
                    fontFamily: "Rubik",
                    color: "#194b7e",
                    fontSize: 18,
                    marginBottom: 20,
                  }}
                >
                  Please use the{" "}
                  <span style={{ color: "#005DAC" }}>login details</span> of{" "}
                  <span style={{ color: "#005DAC" }}>KFINTECH MFS</span> website
                  Distributor Services
                </div> */}

              <div className="form_tabs_list">
                <span
                  className="sign_in_btn sign_btn mouse-pointer"
                  onClick={() => this.props.history.push("./login")}
                >
                  Sign In
                </span>
                <span
                  className="sign_up_btn sign_btn mouse-pointer"
                  onClick={() => this.props.history.push("./register")}
                >
                  Sign Up
                </span>
              </div>
              {/* <div
                  style={{
                    height: "200px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #00000033",
                    marginTop: "50px",
                  }}
                >
                  <div>
                    <h5 style={{ textAlign: "center" }}>
                      Sign in for Bajaj DIT will be operational very soon.
                    </h5>
                    <h5 style={{ textAlign: "center" }}>Thanks </h5>
                  </div>
                </div> */}
              <Input
                maxLength={50}
                name={"User ID"}
                // autoFocus={true}
                bordercolor="#e5e9ec"
                image={"/images/id-card.svg"}
                value={username.value}
                onChange={this.changeValue("username")}
                onBlur={this.showError("username")}
                isShowError={username.isError}
                errorMessage={username.errorMessage}
                inputref={(ele) => (this.usernameField = ele)}
                onKeyPress={this.keyPress("username")}
                placeholder={"Please enter your User Id"}
              />
              <div
                className="login-forgot mouse-pointer"
                onClick={() => this.props.history.push("/forgot-userid")}
              >
                Forgot User Id?
              </div>
              <Input
                maxLength={50}
                name={"Password"}
                errorMessage={password.errorMessage}
                bordercolor="#e5e9ec"
                image={"/images/locked.svg"}
                type={!!this.state.showPassword ? "text" : "password"}
                image2={
                  !!this.state.showPassword
                    ? "/images/Bajaj_eye.svg"
                    : "/images/Bajaj_eye_hide.svg"
                }
                onClick={() => {
                  this.setState({
                    showPassword: !this.state.showPassword,
                  });
                }}
                value={password.value}
                onChange={this.changeValue("password")}
                onBlur={this.showError("password")}
                isShowError={password.isError}
                inputref={(ele) => (this.passwordField = ele)}
                onKeyPress={this.keyPress()}
                placeholder={"Please enter your Password"}
              />
              <div
                className="login-forgot mouse-pointer"
                onClick={() => this.props.history.push("/forgot-password")}
              >
                Forgot password?
              </div>

              <div
                className="login-terms-conditions"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* <Checkbox
                  onClick={this.toggleCheckbox}
                  // value={combo.label}
                  checked={terms}
                  color="secondary"
                /> */}
                {/* <div className="login-term-text">
                  I have understood and agree to your{" "}
                  <a href={"/terms-conditions"} target="_blank">
                    Terms and Conditions*
                  </a>
                </div> */}
              </div>
              <Signbutton
                buttontitle="Sign in"
                onClick={this.signIn}
                // marginTop={"20"}
              />

              <div className="login-no-account">
                <span className="login-no-account-description">
                  Empaneled but don't have an account yet?{" "}
                </span>
                <span
                  className="login-no-account-span mouse-pointer"
                  onClick={() => this.props.history.push("/register")}
                >
                  Sign up now
                </span>
              </div>

              <div className="distributor-links-column">
                {/* <div className="distributor-links">
                  <span
                    onClick={() => this.props.history.push("/common-arn-link")}
                    target="_blank"
                    className="distributor-links-item"
                  >
                    Customized ARN – Link
                    <Tooltip
                      title="Generate common ARN link - Investor can select schemes at their end"
                      arrow
                    >
                      <Image
                        src={"/images/information.png"}
                        alt="info"
                        style={{ height: "15px", marginLeft: "10px" }}
                      />
                    </Tooltip>
                  </span>
                  <span
                    // href="https://transact.miraeassetmf.co.in/miraedit/Mirae/DistributorLinkGeneration"
                    onClick={this.gotogenerateArnLink}
                    target="_blank"
                    className="distributor-links-item"
                  >
                    Scheme ARN – link
                    <Tooltip
                      title="Generate scheme specific ARN link for your investors"
                      arrow
                    >
                      <Image
                        src={"/images/information.png"}
                        alt="info"
                        style={{ height: "15px", marginLeft: "10px" }}
                      />
                    </Tooltip>
                  </span>
                </div> */}
                {/* <div className="distributor-links">
                  <span
                    target="_blank"
                    onClick={this.gotoDistributorEmapanellement}
                    className="distributor-links-item"
                  >
                    Distributor Empanelment
                    <Tooltip
                      title="Not yet empanelled with us? - Empanel Now!! 
                      Empanelment is just a click away "
                      arrow
                    >
                      <Image
                        src={"/images/information.png"}
                        alt="info"
                        style={{ height: "15px", marginLeft: "10px" }}
                      />
                    </Tooltip>
                  </span>
                  <span
                    target="_blank"
                    onClick={() => {
                      window.open("https://businessready.miraeassetmf.co.in/");
                    }}
                    className="distributor-links-item"
                  >
                    Co-brand Here
                    <Tooltip title="Co-brand here " arrow>
                      <Image
                        src={"/images/information.png"}
                        alt="info"
                        style={{ height: "15px", marginLeft: "10px" }}
                      />
                    </Tooltip>
                  </span>
                </div> */}
                <div className="distributor-links" style={{ marginBottom: 20 }}>
                  <span
                    target="_blank"
                    onClick={this.gotoDistributorEmapanellement}
                    className="distributor-links-item"
                  >
                    <span style={{ color: "black" }}>First Time User?</span>{" "}
                    Click Here
                    <Tooltip title="Join our Partner Telegram (Mobile)" arrow>
                      <Image
                        src={"/images/information.png"}
                        alt="info"
                        style={{ height: "15px", marginLeft: "5px" }}
                      />
                    </Tooltip>
                  </span>
                </div>
                <div className="distributor-links">
                  <span
                    target="_blank"
                    // onClick={() => {
                    //   window.open("https://t.me/+W7Ed6Ihx-dthMjk1");
                    // }}
                    className="terms_conditions"
                  >
                    Terms and Conditions
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default connect(
  ({ authReducer }) => {
    const { token } = authReducer;
    return { token };
  },
  { userLogin, removeData, passwordPolicy_JMF }
)(Login);

export function encrypt(text) {
  const str = "acgredf7e2e";
  const str1 = "hseckahdfis234te";
  const decode = btoa(text);
  const encrpytion1 = str + decode + str1;
  const encrpyted = btoa(encrpytion1);
  return encrpyted;
}
